import { Delete, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { DropzoneArea } from 'react-mui-dropzone';

type Props = {
  activeStep: any;
  handleBack: any;
  setUploadedDoc: any;
  handleNext: any;
  uploadedDoc: any;
  handelNavigateBack: any;
};

const UploadPhysicianDoc = (props: Props) => {
  const { activeStep, handleBack, setUploadedDoc, handleNext, uploadedDoc, handelNavigateBack } =
    props;

  const handleFileSelectCaseDetails = (file: any) => {
    if (!file[0]) {
      return;
    }

    setUploadedDoc(file[0]);
  };

  const handleNextSelectedDoc = () => {
    handleNext();
  };

  const handleRemoveFile = () => {
    setUploadedDoc({});
  };

  return (
    <>
      <Box
        sx={{
          border: '1px solid #F2F4F7',
          borderRadius: '20px',
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
        p={1}
      >
        <Box sx={{ p: 5 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <Typography variant="h6">Upload Physician Sign File</Typography>
            <DropzoneArea
              sx={{
                borderRadius: '50px',
                borderColor: '#6C737F',
                width: '70%',
                color: '#6C737F',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              filesLimit={1}
              onChange={(file: any) => handleFileSelectCaseDetails(file)}
              dropzoneText="Drag & Drop or Click here To Browse"
              showFileNames={true}
              Icon={(props: any) => null}
              showAlerts={false}
              showPreviews={false}
              showPreviewsInDropzone={false}
              maxFileSize={10000000}
            />

            <Table sx={{ minWidth: 700 }}>
              <TableHead>
                <TableRow>
                  <TableCell>Document Name</TableCell>
                  <TableCell>File Size</TableCell>
                  <TableCell align="right"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {uploadedDoc?.name ? (
                  <TableRow>
                    <TableCell>{uploadedDoc?.name}</TableCell>
                    <TableCell>{(uploadedDoc.size / 1024).toFixed(2)} KB</TableCell>
                    <TableCell>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        title="Remove file"
                        onClick={() => handleRemoveFile()}
                      >
                        <Delete />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={7}>
                      <Box
                        textAlign="center"
                        p={3}
                      >
                        <Typography
                          color={'text.secondary'}
                          variant="subtitle2"
                        >
                          No File Selected
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Box>
            <Button
              variant="outlined"
              disabled={activeStep === 0}
              startIcon={<KeyboardArrowLeft />}
              onClick={handleBack}
            >
              Back
            </Button>
          </Box>
          <Box>
            <Button
              sx={{ mr: 2, color: '#384250' }}
              onClick={handelNavigateBack}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              endIcon={<KeyboardArrowRight />}
              disabled={!uploadedDoc?.name}
              onClick={handleNextSelectedDoc}
            >
              Continue
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default UploadPhysicianDoc;